import React from 'react';
import './Policy.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container padding">
        <div className="heading">
          <h2>Privacy Policy</h2>
        </div>
        <div className="policy-content">
          <div className="policy-section">
            <h3>Information We Collect</h3>
            
            <div className="policy-subsection">
              <h4>Personal Information:</h4>
              <p>
                We collect personal details such as your name, email address, shipping address, phone number, and payment 
                information when you make a purchase, create an account, or contact us.
              </p>
            </div>
            
            <div className="policy-subsection">
              <h4>Non-Personal Information:</h4>
              <p>
                We may collect non-personal data such as browser type, operating system, and browsing behavior to improve 
                our website and services.
              </p>
            </div>
          </div>

          <div className="policy-section">
            <h3>How We Use Your Information</h3>
            
            <div className="policy-subsection">
              <h4>To Process Orders:</h4>
              <p>We use your personal information to process and fulfill your orders.</p>
            </div>
            
            <div className="policy-subsection">
              <h4>To Communicate:</h4>
              <p>
                We use your contact information to send you updates about your order, respond to inquiries, and send 
                promotional materials if you have opted in.
              </p>
            </div>
            
            <div className="policy-subsection">
              <h4>To Improve Our Services:</h4>
              <p>
                We analyze non-personal information to understand user behavior and enhance our website's performance.
              </p>
            </div>
          </div>

          <div className="policy-section">
            <h3>Information Sharing</h3>
            
            <div className="policy-subsection">
              <h4>Third-Party Service Providers:</h4>
              <p>
                We may share your information with third-party service providers who assist us in operating our website, 
                processing payments, and delivering orders.
              </p>
            </div>
            
            <div className="policy-subsection">
              <h4>Legal Requirements:</h4>
              <p>We may disclose your information if required by law or to protect our rights.</p>
            </div>
          </div>

          <div className="policy-section">
            <h3>Data Security</h3>
            <p>
              We implement appropriate security measures to protect your personal information from unauthorized access, 
              alteration, disclosure, or destruction.
            </p>
          </div>

          <div className="policy-section">
            <h3>Your Rights</h3>
            
            <div className="policy-subsection">
              <h4>Access and Correction:</h4>
              <p>
                You have the right to access and correct your personal information. You can update your account details 
                through our website.
              </p>
            </div>
            
            <div className="policy-subsection">
              <h4>Opt-Out:</h4>
              <p>
                You can opt-out of receiving promotional emails by following the unsubscribe instructions in the emails.
              </p>
            </div>
          </div>

          <div className="policy-section">
            <h3>Changes to This Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the 
              revised date will be indicated at the top of the policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

